module.exports = __webpack_public_path__ + "img/calendar_month.e2719a93.svg";